import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Sun, Wrench, Network, Shield } from 'lucide-react';

const ServiceCard = ({ icon: Icon, title, description }) => {
  return (
    <Card className="border-gray-100 hover:border-emerald-200 transition-all duration-300 hover:shadow-lg group">
      <CardHeader>
        <div className="w-12 h-12 bg-emerald-50 rounded-lg flex items-center justify-center mb-4 group-hover:bg-emerald-100 transition-colors duration-300">
          <Icon className="w-6 h-6 text-emerald-700" />
        </div>
        <CardTitle className="text-xl font-semibold text-gray-900">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription className="text-gray-600 leading-relaxed">
          {description}
        </CardDescription>
      </CardContent>
    </Card>
  );
};

const Services = () => {
  const services = [
    {
      icon: Sun,
      title: 'Utility-Scale Solar Development',
      description: 'Designing and developing large-scale solar power plants that meet strict technical and regulatory requirements for grid integration.'
    },
    {
      icon: Wrench,
      title: 'EPC & Project Execution',
      description: 'End-to-end engineering, procurement, and construction services with a focus on timelines, safety, and performance excellence.'
    },
    {
      icon: Network,
      title: 'Grid Integration & Compliance',
      description: 'Seamless integration with state power grids while maintaining full compliance with DISCOM and government standards.'
    },
    {
      icon: Shield,
      title: 'Long-Term Asset Reliability',
      description: 'Building solar infrastructure designed for decades of reliable operation with minimal maintenance and maximum efficiency.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What We Do</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Building India's renewable energy infrastructure with precision and responsibility
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
